import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';
import type {Disposable, Environment} from 'relay-runtime';
import type {MutationInput} from './MutationTypes';
import type {
	ImportQuickbooksCustomersMutation,
	ImportQuickbooksCustomersMutation$data,
	ImportQuickbooksCustomersMutation$variables,
} from './__generated__/ImportQuickbooksCustomersMutation.graphql';

const mutation = graphql`
	mutation ImportQuickbooksCustomersMutation($input: ImportQuickbooksCustomersInput!) {
		importQuickbooksCustomers(input: $input) {
			unlinkedBillToCount
			company {
				clients(first: 10000) {
					edges {
						node {
							id
							name
							notes
							logoId
							logoDefaultId
							projectCount
							xeroContactId
						}
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<ImportQuickbooksCustomersMutation$variables['input']>,
	onSuccess?: (response: ImportQuickbooksCustomersMutation$data) => void,
	onError?: (error: Error) => void
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return commitMutation<ImportQuickbooksCustomersMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
